module.exports = __webpack_public_path__ + "media/images/web/favicon/android-icon-192x192-0be0a581f22a63afc050e6c04227d616.png";